import {
  Status,
  StatusIndicator,
} from "@amzn/stencil-react-components/status-indicator";
import React from "react";
import { Row } from "@amzn/stencil-react-components/layout";
import { StatusEnum } from "../../../hoc/with-status";
import useArb from "../../../hooks/use-arb";

interface DueDateProps {
  status?: StatusEnum;
  dueDate?: Date;
}

export const DueDateIndicator = ({ status, dueDate }: DueDateProps) => {
  let text: string;
  let color: string;
  let icon: Status;
  const bundle = useArb("HVHChecklistPantherResource");
  const completed = bundle.getMessage("checklist-General-TaskStatus-Completed");
  const unavailable = bundle.getMessage(
    "checklist-General-TaskStatus-Unavailable"
  );
  const overdue = bundle.getMessage("checklist-General-TaskStatus-Overdue");
  const duesoon = bundle.getMessage("checklist-General-TaskStatus-DueSoon");
  const translatedDueDate = bundle.formatMessage("checklist-General-DueDate", {
    date: dueDate,
  });

  switch (status) {
    case StatusEnum.COMPLETED:
      text = completed;
      color = "#D7F3ED";
      icon = Status.Positive;
      break;
    case StatusEnum.INELIGIBLE:
    case StatusEnum.NOT_AVAILABLE_YET:
      text = unavailable;
      color = "#D1D5DA";
      icon = Status.Unavailable;
      break;
    default:
      if (dueDate) {
        text = duesoon + " · " + translatedDueDate;
      } else {
        text = overdue;
      }

      color = "#FFF3CB";
      icon = Status.Warning;
      break;
  }

  return (
    <Row backgroundColor={color} padding="0.25rem">
      <StatusIndicator status={icon} messageText={text} />
    </Row>
  );
};
